/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_File_Name_TextInputs */



/**
* | output |
* | --- |
* | "Please enter a file name:" |
*
* @param {Explorer_Display_File_Name_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_file_name_text = /** @type {((inputs?: Explorer_Display_File_Name_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_File_Name_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer un nom de fichier :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie einen Dateinamen ein:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome file:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите имя файла:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduzca un nombre de archivo:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入文件名：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイル名を入力してください:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया फ़ाइल का नाम दर्ज करें:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira um nome de arquivo:")
	return /** @type {LocalizedString} */ ("Please enter a file name:")
});